'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface SearchBarProps {
  onSearch: (query: string) => void;
  placeholder?: string;
  initialValue?: string;
}

const SearchBar = ({
  onSearch,
  placeholder = 'Поиск товаров...',
  initialValue = '',
}: SearchBarProps) => {
  const [searchQuery, setSearchQuery] = useState(initialValue);
  const [isFocused, setIsFocused] = useState(false);

  // Debounce для уменьшения количества вызовов onSearch
  useEffect(() => {
    const timer = setTimeout(() => {
      onSearch(searchQuery);
    }, 500);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery]);

  useEffect(() => {
    setSearchQuery(initialValue);
  }, [initialValue]);

  const handleClear = () => {
    setSearchQuery('');
    // onSearch будет вызван через useEffect с debounce
  };

  return (
    <div className="relative w-full">
      <div
        className={`flex items-center gap-3 rounded-lg border bg-background px-4 py-3 transition-all duration-250 ${
          isFocused
            ? 'border-accent shadow-md ring-2 ring-accent/20'
            : 'border-input shadow-sm'
        }`}
      >
        <Icon
          name="MagnifyingGlassIcon"
          size={20}
          className={`flex-shrink-0 transition-colors duration-250 ${
            isFocused ? 'text-accent' : 'text-text-secondary'
          }`}
        />
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          placeholder={placeholder}
          className="flex-1 bg-transparent font-body text-base text-text-primary placeholder:text-text-secondary focus:outline-none"
        />
        {searchQuery && (
          <button
            onClick={handleClear}
            className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full text-text-secondary transition-all duration-250 hover:bg-muted hover:text-text-primary active:scale-90"
            aria-label="Очистить поиск"
          >
            <Icon name="XMarkIcon" size={16} />
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchBar;